import React from 'react'

import { Domain } from 'Types/Domain'
import { GetTagMethod } from './MethodSelector.models'
import { DiyMethod } from './Methods/DiyMethod'
import { SendCode } from './Methods/SendCode'
import { Wordpress } from './Methods/Wordpress'
import { GoogleTagManager } from './Methods/GoogleTagManager'
import { NoGtmGoogleTagManager } from './NoGtmGoogleTagManager'
import { useSplit } from 'Hooks/useSplit'

interface InstructionRendererProps {
  tagMethod: GetTagMethod
  tagUrl: string
  domain: Domain | undefined
}

export const RenderMethod = ({ tagUrl, tagMethod, domain }: InstructionRendererProps) => {
  const showAutoGtmButton = useSplit('CE_GTM_AUTO')
  switch (tagMethod) {
    case 'googleTagManager':
      return showAutoGtmButton ? (
        <GoogleTagManager tagUrl={tagUrl} domain={domain} />
      ) : (
        <NoGtmGoogleTagManager tagUrl={tagUrl} domain={domain} />
      )
    case 'directInstallation':
      return <DiyMethod domainHashCode={domain?.tagHashCode || ''} tagUrl={tagUrl} />
    case 'wordpressPlugin':
      return <Wordpress domain={domain} />
    case 'emailDev':
      return <SendCode domainId={domain?.id || 0} />
    default:
      return <DiyMethod domainHashCode={domain?.tagHashCode || ''} tagUrl={tagUrl} />
  }
}
